import styled from '@emotion/styled';
import { Text } from '@croquiscom-pvt/zds';
import { numberWithCommas } from '@common/utils';

export const PriceTotalRow = ({
  label,
  price,
  price_color,
  discount_text,
}: {
  label: string;
  price: number;
  price_color?: string;
  discount_text?: string;
}) => (
  <TotalPriceRow>
    <Text variant='Body_15_SemiBold' v3Color='gray900'>
      {label}
    </Text>
    <TotalPriceInfo>
      {discount_text && (
        <Text variant='Body_13_Medium' style={{ position: 'relative', top: '1px', color: price_color }}>
          {discount_text}
        </Text>
      )}
      <Text variant='Head_20_Bold' style={{ color: price_color }}>
        {numberWithCommas(price)}원
      </Text>
    </TotalPriceInfo>
  </TotalPriceRow>
);

const TotalPriceRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TotalPriceInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;
